import React from 'react';
import { Tag } from 'antd';
import type { TagProps } from 'antd/lib/tag';
import type { IconType } from 'react-icons/lib';
import styles from './styles.module.scss';

const BasicTag: React.FC<{
  color: TagProps['color'];
  text: string;
  Icon: IconType;
}> = ({ color, text, Icon }) => {
  return (
    <Tag color={color} className={styles.tag}>
      <Icon />
      {text}
    </Tag>
  );
};

export default BasicTag;
